module.exports = __webpack_public_path__ + "static/media/appIconLogo.5e8b8683.png";